module.exports = __webpack_public_path__ + "img/fruits-a-coque.6c3b0340.svg";